module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.id,
      "tabindex": "-1"
    }
  }, [_vm._h('div', {
    staticClass: "modal-dialog"
  }, [_vm._h('div', {
    staticClass: "modal-content"
  }, [_vm._h('div', {
    staticClass: "modal-header"
  }, [_vm._h('div', {
    staticClass: "clickable pull-left lead",
    attrs: {
      "title": "Toggle Favorite",
      "style": "color:gold"
    },
    on: {
      "click": _vm.toggleFav
    }
  }, [(_vm.isFav) ? _vm._h('span', {
    staticClass: "glyphicon glyphicon-star"
  }) : _vm._h('span', {
    staticClass: "glyphicon glyphicon-star-empty"
  }), " "]), " ", _vm._m(0), " ", _vm._h('h3', {
    staticClass: "modal-title"
  }, [_vm._s(_vm.drug.name)])]), " ", _vm._h('div', {
    staticClass: "modal-body"
  }, [_vm._h('div', {
    staticClass: "panel panel-default"
  }, [_vm._h('div', {
    staticClass: "panel-body"
  }, [_vm._h('div', {
    staticClass: "row"
  }, [_vm._h('div', {
    staticClass: "col-sm-6"
  }, [_vm._h('p', [_vm._m(1), " ", (_vm.patient.wt !== null) ? _vm._h('span', [_vm._s(_vm.patient.wt) + " kg"]) : _vm._h('span', ["Not provided"]), " "])]), " ", _vm._h('div', {
    staticClass: "col-sm-6"
  }, [_vm._h('p', [_vm._m(2), " ", (_vm.patient.age.y !== null) ? _vm._h('span', [_vm._s(_vm.patient.age.y) + " years"]) : _vm._e(), " ", (_vm.patient.age.m !== null) ? _vm._h('span', [_vm._s(_vm.patient.age.m) + " months"]) : _vm._e(), " ", (_vm.patient.age.d !== null) ? _vm._h('span', [_vm._s(_vm.patient.age.d) + " days"]) : _vm._e(), " ", (_vm.patient.age.y === null && _vm.patient.age.m === null && _vm.patient.age.d === null) ? _vm._h('span', ["Not provided"]) : _vm._e()])])])])]), " ", _vm._l((_vm.drug.form), function(item) {
    return [_vm._h('div', {
      staticClass: "panel",
      class: {
        'panel-info': item.gen, 'panel-default': !item.gen
      }
    }, [_vm._h('div', {
      staticClass: "panel-heading"
    }, [_vm._h('div', {
      staticClass: "panel-title"
    }, ["\n\t\t\t\t    " + _vm._s(item.mode) + " " + _vm._s(_vm.drug.name) + " ", (item.content) ? _vm._h('span', ["(" + _vm._s(item.content) + ")"]) : _vm._e()])]), " ", _vm._h('div', {
      staticClass: "panel-body"
    }, [_vm._h('div', {
      staticClass: "table-responsive"
    }, [_vm._h('table', {
      staticClass: "table"
    }, [_vm._h('tbody', [_vm._l((item.dose), function(i) {
      return [(i.val[0]) ? [_vm._h('tr', [_vm._m(3, true), " ", _vm._h('td', [_vm._s(i.val[0]), (i.val[1]) ? _vm._h('span', [" - " + _vm._s(i.val[1])]) : _vm._e(), " " + _vm._s(i.unit)]), " ", _vm._h('td', [(i.txt) ? _vm._h('span', [_vm._s(i.txt)]) : _vm._h('span', ["per dose"])])]), " ", _vm._h('tr', [_vm._h('td', [(i.perKg && (!i.limit || i.limit[0] != i.val[0] || i.limit[1] != i.val[1])) ? [(i.perKg) ? [(i.perKg[0]) ? _vm._h('span', ["( " + _vm._s(i.perKg[0]), (i.perKg[1]) ? _vm._h('span', ["-" + _vm._s(i.perKg[1])]) : _vm._e(), " " + _vm._s(i.unit) + "/kg"]) : _vm._e(), " ", (i.adult) ? ["\n\t\t\t\t\t\t\t\t    ; Adult: " + _vm._s(i.adult[0]), (i.adult[1] && i.adult[1] != i.adult[0]) ? _vm._h('span', ["-" + _vm._s(i.adult[1])]) : _vm._e(), " " + _vm._s(i.unit) + "\n\t\t\t\t\t\t\t\t"] : _vm._e(), " ", (i.limit) ? ["\n\t\t\t\t\t\t\t\t    ; Limit: " + _vm._s(i.limit[0]), (i.limit[1] && i.limit[1] != i.limit[0]) ? _vm._h('span', ["-" + _vm._s(i.limit[1])]) : _vm._e(), " " + _vm._s(i.unit) + "\n\t\t\t\t\t\t\t\t"] : _vm._e(), "\n\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t    "] : _vm._e()] : _vm._e()]), " ", _vm._h('td', [(i.comment) ? _vm._h('span', [_vm._s(i.comment)]) : _vm._e()])])] : _vm._e()]
    })])])]), " ", (item.comment) ? _vm._h('div', {
      staticClass: "well"
    }, ["\n\t\t\t\t    " + _vm._s(item.comment) + "\n\t\t\t\t"]) : _vm._e()])])]
  }), " ", (_vm.drug.comment) ? _vm._h('div', {
    staticClass: "well"
  }, ["\n\t\t\t" + _vm._s(_vm.drug.comment) + "\n\t\t    "]) : _vm._e()]), " ", _vm._m(4)])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._h('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, ["×"])])
},function (){var _vm=this;
  return _vm._h('strong', ["Body Weight:"])
},function (){var _vm=this;
  return _vm._h('strong', ["Age:"])
},function (){var _vm=this;
  return _vm._h('td', {
    staticClass: "active",
    attrs: {
      "rowspan": "2"
    }
  }, ["Dose:"])
},function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "modal-footer"
  }, [_vm._h('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, ["Close"])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3387d939!./~/vue-loader/lib/selector.js?type=template&index=0!./src/DrugView.vue
// module id = 143
// module chunks = 0